import Row from './src/row';

Row.install = function(Vue) {
  Vue.component(Row.name, Row);
};

export default Row;




// WEBPACK FOOTER //
// ./src/components/row/index.js